import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { catchError, Observable } from 'rxjs';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { TranslateDirective } from '../../Utilites/Directives/translate.directive';
import { TranslatePipe } from '../../Utilites/Pipe/translate.pipe';

@Component({
  selector: 'app-dynamic-page-creation',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    DynamicFormQuestionComponent,
    MatIconModule,
    MatSlideToggleModule,
    TranslateDirective,
    TranslatePipe,
  ],
  templateUrl: './dynamic-page-creation.component.html',
  styleUrl: './dynamic-page-creation.component.scss',
})
export class DynamicPageCreationComponent implements OnInit {
  @Input() pageTitle: string = 'Create New Page';
  @Input() questions$!: Observable<Inputfiledsbase<string>[]>;

  @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  questions: Inputfiledsbase<string>[] = [];
  openInNewTabControl: FormControl;
  pageForm: FormGroup;
  TabButton: boolean = false;
  submitButtonText: string = 'Submit';

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DynamicPageCreationComponent>,
  ) {
    this.pageForm = this.fb.group({});

    this.openInNewTabControl = new FormControl(false);

    if (this.data?.openInNewTab) {
      this.pageForm.addControl('open_in_new_tab', this.openInNewTabControl);
    }

    if (this.data?.pageTitle) {
      this.pageTitle = this.data.pageTitle;
    }
    if (this.data?.questions$) {
      this.data.questions$
        .pipe(
          catchError((err) => {
            console.error('Error loading questions:', err);
            return [];
          }),
        )
        .subscribe((questions: any) => {
          this.questions = questions || [];

          // 1️⃣ Add dynamic controls FIRST
          this.addDynamicControls(this.questions);

          // 2️⃣ Add ID control if edit
          if (this.data?.initialData?.id) {
            this.pageForm.addControl(
              'id',
              this.fb.control(this.data.initialData.id),
            );
          }

          if (this.data?.initialData) {
            const patchedData = {
              ...this.data.initialData,
              open_in_new_tab: !!this.data.initialData.open_in_new_tab,
            };

            this.pageForm.patchValue(patchedData);
          }
        });
    }
  }

  ngOnInit(): void {
    this.TabButton = this.data?.TabButton || false;
    this.submitButtonText = this.data?.submitButtonText || 'Submit';
  }

  private addDynamicControls(questions: Inputfiledsbase<string>[]): void {
    questions.forEach((question) => {
      const validators = question.required ? [Validators.required] : [];
      this.pageForm.addControl(
        question.key,
        this.fb.control(question.value || '', validators),
      );
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  trackByQuestionKey(index: number, question: Inputfiledsbase<string>): string {
    return question.key;
  }

  onSubmit(): void {
    if (this.pageForm.valid) {
      this.dialogRef.close(this.pageForm.value);
    } else {
      Object.keys(this.pageForm.controls).forEach((key) => {
        const control = this.pageForm.get(key);
        if (control?.invalid) {
          console.log(`${key} is invalid`);
        }
      });
    }
  }
}
